var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense, useContext, useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Context from "@/context/createContext";
import { Image, Select } from "antd";
import { pcRoutes } from "./systemRoutes";
import hmjLogo from "@/common/png/hmjLogo.png";
import jingLogo from "@/common/png/jing.png";
import { getLanguage } from "@/common/funJs";
import Exception from "@/components/Exception";
import { pcOptions } from "@/interface/status";
import "./index.less";
var Option = Select.Option;
var routes = pcRoutes.map(function (_a) {
    var trunk = _a.trunk, config = __rest(_a, ["trunk"]);
    var Trunk = lazy(function () { return trunk(); });
    return __assign(__assign({}, config), { component: (_jsx(Suspense, __assign({ fallback: _jsx("div", { children: "Loading..." }) }, { children: _jsx(Trunk, {}) }))) });
});
var PC = function (_a) {
    var error = _a.error, errorInfo = _a.errorInfo;
    var _b = useState(localStorage.getItem("locale") || localStorage.getItem("defaultLng") || "zh"), language = _b[0], setLanguage = _b[1];
    var type = useContext(Context).type;
    useEffect(function () {
        console.log("页面加载完成，开始执行...");
        var locale = localStorage.getItem("locale");
        console.log("locale=" + locale);
        if (locale === "zh-cn" || locale === null) {
            console.log("system=" + navigator.language);
            var languageSys = (navigator.language).toLowerCase();
            var lang = languageSys === "zh-cn" || languageSys === "zh-tw" || languageSys === "zh-hk" ? "zh" : "en";
            console.log("lang=" + lang);
            //   localStorage.setItem("locale", lang);
            handleChangeLanguage(lang);
            console.log("页面加载完成，结束执行...");
        }
    }, []);
    // 切换中、英文
    var handleChangeLanguage = function (value) {
        if (localStorage.getItem("locale") !== value) {
            setLanguage(value);
            localStorage.setItem("locale", value);
            window.location.reload();
        }
    };
    return (_jsxs("div", __assign({ className: "pcWrap" }, { children: [_jsx("div", __assign({ className: "header" }, { children: _jsxs("header", { children: [_jsx(Image, { src: hmjLogo, preview: false }), _jsx("div", __assign({ className: "pcLanguage" }, { children: _jsx(Select, __assign({ defaultValue: getLanguage(language, false)["value"], bordered: false, showArrow: false, onChange: handleChangeLanguage }, { children: pcOptions.map(function (item) {
                                    return (_jsxs(Option, __assign({ value: item.value, className: "selectOptionItem" }, { children: [_jsx("span", __assign({ className: "pcLanguageIcon" }, { children: item.span })), item.label] }), item.value));
                                }) })) }))] }) })), error ?
                _jsx(Exception, { type: errorInfo.type, title: errorInfo.title, description: errorInfo.description })
                :
                    _jsx("main", { children: _jsxs(Switch, { children: [routes.map(function (item) { return (_jsx(Route, { path: item.path, exact: item.exact, render: function () { return item.component; } }, item.path)); }), _jsx(Route, __assign({ path: "*", exact: true }, { children: _jsx(Exception, { type: "error", title: "error", description: "" }) }))] }) }), type &&
                _jsx("footer", { children: _jsxs("div", __assign({ className: "ban-pan" }, { children: [_jsx("span", { children: "\u00A9 2018  \u5148\u80DC\u4E1A\u8D22 \u6CAAICP\u590718031611\u53F7-6 " }), _jsxs("a", __assign({ target: "_blank", href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702007136" }, { children: [_jsx("img", { src: jingLogo, alt: "" }), _jsx("p", { children: "\u6CAA\u516C\u7F51\u5B89\u5907 31010702007136\u53F7" })] }))] })) })] })));
};
export default PC;
